import type { FeatureFlags } from '@/features/feature-flag/_models/feature-flags';
import type { TFunction } from '@/i18n';
import { FALLBACK_TEXT } from '@/utils';
import type { z } from 'zod';

export const getFeatureFlagsLabel = (
  t: TFunction,
  key: keyof z.infer<typeof FeatureFlags>,
) => {
  switch (key) {
    case 'bulkPdf':
      return t('bulk-pdf');
    default:
      return FALLBACK_TEXT;
  }
};
